import { Component, OnInit, ViewChild } from '@angular/core';
import { NavController, NavParams, Platform, ModalController, AlertController, ToastController, LoadingController } from '@ionic/angular';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service';
import { RestapiService } from 'src/app/service/api/restapi.service';
import { Router } from '@angular/router';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import { File } from '@ionic-native/file/ngx';
import { ActionSheetController } from '@ionic/angular';
import { Base64 } from '@ionic-native/base64/ngx';
import { FilePath } from '@ionic-native/file-path/ngx';
import { FileChooser } from '@ionic-native/file-chooser/ngx';
import { DomSanitizer } from '@angular/platform-browser';
import { RatingComponent } from 'ionic-emoji-rating';
import { SIGHUP } from 'constants';
import * as $ from "jquery";

@Component({
    selector: 'app-countrylist',
    templateUrl: './feedbackModal.component.html',
    styleUrls: ['./feedbackModal.component.scss'],
})
export class FeedbackModal implements OnInit {
    currentpath;
    allcountryLists: any = [];
    filtercountryLists: any = [];
    searchTerm: any;
    selectedSmiley: any;
    suggestionBox: any;
    smiley: any;
    option: any;

    constructor(public formBuilder: FormBuilder,
        private router: Router,
        public navctrl: NavController,
        public platform: Platform,
        public cmndeclaration: CommonDeclarationService,
        public cmndef: CommonDefinitionService,
        private camera: Camera,
        public actionSheetController: ActionSheetController,
        private file: File,
        public api: RestapiService,
        public base64: Base64,
        public filePath: FilePath,
        public fileChooser: FileChooser,
        public _DomSanitizer: DomSanitizer,
        public modalCtrl: ModalController,
        public alertController: AlertController,
        public toastController: ToastController,
        public loadingCtrl: LoadingController,
        public navparam: NavParams) {
        this.selectedSmiley = '';
        this.option = '';

    }
    ngOnInit() {

    }

    selectSmiley(i) {
        var attach = "#" + i;
        $(attach).css("width", "50px");
        $(attach).css("margin-top", "-9px");
        this.selectedSmiley = i;

        if (this.selectedSmiley == 'smiley1') {
            this.option = "1 Star Rating";
            $("#smiley2").css("width", "40px");
            $("#smiley2").css("margin-top", "0px");
            $("#smiley3").css("width", "40px");
            $("#smiley3").css("margin-top", "0px");
            $("#smiley4").css("width", "40px");
            $("#smiley4").css("margin-top", "0px");
            $("#smiley5").css("width", "40px");
            $("#smiley5").css("margin-top", "0px");
            $(".onetothree").css("display", "block");
            $(".fourtofive").css("display", "none");
        }
        if (this.selectedSmiley == 'smiley2') {
            this.option = "2 Star Rating";
            $("#smiley1").css("width", "40px");
            $("#smiley1").css("margin-top", "0px");
            $("#smiley3").css("width", "40px");
            $("#smiley3").css("margin-top", "0px");
            $("#smiley4").css("width", "40px");
            $("#smiley4").css("margin-top", "0px");
            $("#smiley5").css("width", "40px");
            $("#smiley5").css("margin-top", "0px");
            $(".onetothree").css("display", "block");
            $(".fourtofive").css("display", "none");
        }
        if (this.selectedSmiley == 'smiley3') {
            this.option = "3 Star Rating";
            $("#smiley1").css("width", "40px");
            $("#smiley1").css("margin-top", "0px");
            $("#smiley2").css("width", "40px");
            $("#smiley2").css("margin-top", "0px");
            $("#smiley4").css("width", "40px");
            $("#smiley4").css("margin-top", "0px");
            $("#smiley5").css("width", "40px");
            $("#smiley5").css("margin-top", "0px");
            $(".onetothree").css("display", "block");
            $(".fourtofive").css("display", "none");
        }
        if (this.selectedSmiley == 'smiley4') {
            this.option = "4 Star Rating";
            $("#smiley1").css("width", "40px");
            $("#smiley1").css("margin-top", "0px");
            $("#smiley3").css("width", "40px");
            $("#smiley3").css("margin-top", "0px");
            $("#smiley2").css("width", "40px");
            $("#smiley2").css("margin-top", "0px");
            $("#smiley5").css("width", "40px");
            $("#smiley5").css("margin-top", "0px");
            $(".onetothree").css("display", "none");
            $(".fourtofive").css("display", "block");
        }
        if (this.selectedSmiley == 'smiley5') {
            this.option = "5 Star Rating";
            $("#smiley1").css("width", "40px");
            $("#smiley1").css("margin-top", "0px");
            $("#smiley3").css("width", "40px");
            $("#smiley3").css("margin-top", "0px");
            $("#smiley4").css("width", "40px");
            $("#smiley4").css("margin-top", "0px");
            $("#smiley2").css("width", "40px");
            $("#smiley2").css("margin-top", "0px");
            $(".onetothree").css("display", "none");
            $(".fourtofive").css("display", "block");
        }
    }
    goback(c) {
        this.modalCtrl.dismiss(c);
    }

    gonavback() {
        this.modalCtrl.dismiss();
    }
    async submitSmiley() {
        const loading = await this.loadingCtrl.create({
            cssClass: 'my-loading-class'
        });
        if(this.selectedSmiley == "") {
            this.presentAlertConfirm();
            loading.dismiss();
            return false;
        } else {
            $(".showSection").css("display", "block");
        } 
    }

    async submitFeedback() {
        const loading = await this.loadingCtrl.create({
            cssClass: 'my-loading-class'
        });
        loading.present();
        console.log(this.selectedSmiley);
        console.log(this.suggestionBox);
        if (this.suggestionBox == undefined) {
            this.suggestionBox = '';
        }

        if(this.selectedSmiley == "") {
            this.presentAlertConfirm();
            loading.dismiss();
            return false;
        }

        if (this.suggestionBox == '') {
            if(this.selectedSmiley == "smiley1" || this.selectedSmiley == "smiley2" || this.selectedSmiley == "smiley3") {
                $(".showerror").css("display", "block");
                $(".showerror1").css("display", "none");
                loading.dismiss();
                return false;
            } else if(this.selectedSmiley == "smiley4" || this.selectedSmiley == "smiley5") {
                $(".showerror").css("display", "none");
                $(".showerror1").css("display", "block");
                loading.dismiss();
                return false;
            }
        } else {
            if (this.selectedSmiley == 'smiley1') {
                this.smiley = 1;
            }
            if (this.selectedSmiley == 'smiley2') {
                this.smiley = 2;
            }
            if (this.selectedSmiley == 'smiley3') {
                this.smiley = 3;
            }
            if (this.selectedSmiley == 'smiley4') {
                this.smiley = 4;
            }
            if (this.selectedSmiley == 'smiley5') {
                this.smiley = 5;
            }
            var json = {
                "actionType": "FEEDBACK_RATING",
                "userSessionID": localStorage.userSessionId,
                "userChatSessionID": localStorage.userChatSessionId,
                "rating": this.smiley,
                "feedback": this.suggestionBox,
                "langCode": "en",
                "metadata": {
                    "channelId": "1",
                    "ip": "",
                    "imei": "",
                    "platform": "Webbot",
                    "deviceVersion": "",
                    "deviceModel": "Chrome",
                    "version": "1.0.4"
                }
            };
            this.api.postapi("webbotVAAction", json).then(res => {
                loading.dismiss();
                this.modalCtrl.dismiss();
                this.presentToast();
            }, err => {
                console.log(err);
            })
        }
    }

    async presentAlertConfirm() {
        const alert = await this.alertController.create({
            cssClass: 'my-custom-class',
            header: 'Error',
            message: "Please select any one of the rating.",
            buttons: [
                {
                    text: 'Ok',
                    handler: () => {

                    }
                }
            ]
        });

        await alert.present();
    }

    async presentToast() {
        const toast = await this.toastController.create({
            message: 'Feedback Submitted Successfully.',
            duration: 3000,
            position: 'bottom',
            keyboardClose: true
        });
        toast.present();
    }
}